<template>
    <client-page>
        <page-section class="page-section--first page-section--last">
            <template slot="tit">{{ groupText }}</template>

            <template v-if="items.length">
                <v-row>
                    <v-col v-for="item in items" :key="item._id" cols="12">
                        <v-card flat rounded="" :to="`${$route.path}/${item._id}`">
                            <v-img cover :src="item?.thumb?.url" :aspect-ratio="$vuetify.breakpoint.lgAndUp ? 1200 / 240 : 300 / 100" />
                        </v-card>
                    </v-col>
                </v-row>

                <div class="pagination-wrap">
                    <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" class="mt-2" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
                </div>
            </template>
            <template v-else-if="!loading">
                <div class="text-center">
                    <div class="mb-18px mb-md-24px">
                        <v-icon size="60px" color="primary">mdi-calendar-star</v-icon>
                    </div>
                    <div class="tit tit--sm">등록된 {{ groupText }} 항목이 없습니다.</div>
                    <div class="txt txt--sm mt-8px">상품 목록을 확인해주세요.</div>

                    <div class="btn-wrap btn-wrap--lg">
                        <v-row justify="center" class="row--sm">
                            <v-col cols="6" sm="auto">
                                <v-btn color="primary" to="/shop" class="v-size--xx-large w-100 min-w-sm-200px">쇼핑 계속하기</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import api from "@/api";
import { EXHIBITION_GROUPS } from "@/assets/variables";

import ClientPage from "@/components/client/templates/client-page.vue";
import PageSection from "@/components/client/templates/page-section.vue";

const groups = Object.values(EXHIBITION_GROUPS);

export default {
    components: {
        ClientPage,
        PageSection,
    },
    data: () => ({
        exhibitions: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        items() {
            return [...this.exhibitions];
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        group() {
            return this.$route.query.group || groups[0].value;
        },
        groupText() {
            return EXHIBITION_GROUPS[this.group]?.text;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            query.group = this.group;
            return { ...query };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        async init() {
            try {
                this.search();
            } catch (error) {
                console.error(error);
            }
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, exhibitions } = await api.v1.shop.exhibitions.gets({
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.exhibitions = exhibitions.map((item, index) => ({ index: summary.totalCount - (this.page - 1) * this.limit - index, ...item }));
            } catch (error) {
                this.$handleError(error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
